import clsx from 'clsx';
import React from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'tertiary';
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: React.ReactNode;
  className?: string;
  mode?: 'toggle' | 'default';
  toggled?: boolean;
}

const sizeClassMap: Record<ButtonSize, string> = {
  sm: 'px-3 py-1 text-sm font-semibold',
  md: 'px-4 py-1 text-base font-semibold',
  lg: 'px-6 py-2 text-lg font-bold',
};

const variantClassMap = (variant: ButtonVariant, mode: 'toggle' | 'default', toggled?: boolean) => {
  const record = {
    primary:
      'bg-color-bg-primary text-color-text-inverse hover:bg-color-bg-primary-hover active:bg-color-bg-primary-active disabled:!bg-blue-80 disabled:!text-white',
    secondary: 'text-color-bg-primary border-2 border-color-primary disabled:opacity-70',
    tertiary: 'text-color-bg-primary disabled:opacity-70',
  };

  if (mode === 'toggle' && !toggled && variant === 'primary') {
    return 'bg-color-bg-secondary text-color-text-primary hover:bg-color-bg-secondary-hover active:bg-color-bg-secondary-active disabled:bg-color-bg-secondary-disabled';
  }

  return record[variant];
};

export const GCashButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'primary', size = 'md', children, className, mode = 'default', toggled, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        className={clsx(
          'focus-visible:ring-color-bg-primary flex-1 rounded-full tracking-wide transition-colors focus:outline-none focus-visible:ring-2',
          variantClassMap(variant, mode, toggled),
          sizeClassMap[size],
          className
        )}
        {...rest}
      >
        {children}
      </button>
    );
  }
);

GCashButton.displayName = 'GCashButton';
